<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  props: {
    value: { type: Array, default: () => [] },
    listSpecialties: { type: Array, default: () => [] },
    permission: { type: Boolean, default: false }
  },
  data() {
    return {
      localItems: [...this.value],
      currentItem: {}
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.localItems = [...(newVal || [])]
      },
      deep: true
    }
  },
  methods: {
    addItem() {
      if (!this.currentItem || !this.currentItem.specialty) return
      this.localItems.push({ ...this.currentItem })
      this.currentItem = {}
      this.$emit('input', this.localItems)
    },
    removeItem(index) {
      this.localItems.splice(index, 1)
      this.$emit('input', this.localItems)
    }
  }
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <label class="specialty">Tipo Tratamento:</label>
        <Multiselect
          v-model="currentItem.specialty"
          :options="listSpecialties"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecione o Tratamento"
          :select-label="'Pressione Enter para selecionar'"
          :deselect-label="'Pressione Enter para remover'"
          label="name"
          track-by="id"
        />
      </div>
      <div class="col-md-2">
        <label>Valor do Atendimento</label>
        <input @input="formatInputFloat($event, currentItem, 'service_value')" v-model="currentItem.service_value" type="text" class="form-control text-right" />
      </div>
      <div class="col-md-2" v-if="permission">
        <label>Valor do Repasse</label>
        <input @input="formatInputFloat($event, currentItem, 'transfer_amount')" v-model="currentItem.transfer_amount" type="text" class="form-control text-right" />
      </div>
      <div class="col-md-2">
        <button type="button" class="btn btn-primary mt-4" @click="addItem">
          <span class="fas fa-plus-circle"></span> Incluir
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mt-2">
        <table class="table table-bordered table-striped table-sm">
          <thead>
            <tr>
              <th class="text-center">Tipo de Tratamento</th>
              <th class="text-center">Vlr Atendimento</th>
              <th class="text-center" v-if="permission">Vlr Repasse</th>
              <th class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in localItems" :key="index">
              <td>{{ item.specialty && item.specialty.name ? item.specialty.name : '' }}</td>
              <td class="text-right">R$ {{ item.service_value }}</td>
              <td class="text-right" v-if="permission">R$ {{ item.transfer_amount }}</td>
              <td class="text-center">
                <button type="button" class="btn btn-danger" @click="removeItem(index)">
                  <span class="fas fa-trash-alt"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
